const defaultState = {
  report: {},
  error: null,
  fetching: false,
  fetched: false
};

const getDisasterReportReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'DISASTER_REPORT_CLEAR': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: null
      };
    }
    case 'DISASTER_REPORT_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true, report: {}
      };
    }
    case 'DISASTER_REPORT_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, report: action.payload.data
      };
    }
    case 'DISASTER_REPORT_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        report: {},
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default getDisasterReportReducer;


// WEBPACK FOOTER //
// ./src/reducers/getDisasterReport.js